export const getters = {
  budgetsystem: state => state.budgetsystem,
  budgetsystems: state => state.budgetsystems
}

const GET_BUDGETSYSTEM = 'budgetsystem/budgetsystem'
const GET_BUDGETSYSTEMS = 'budgetsystem/budgetsystems'

export const gettersTypes = {
  GET_BUDGETSYSTEM,
  GET_BUDGETSYSTEMS
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/getters.js